export default {
  loginout: '退出',
  login: '登陆',
  logout: '退出',
  changepasswd: '修改密码',
  changeLanguage: '更改语言',
  safeCenter: '安全中心'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/home.js